import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';

const XGoOpenShift = () => {
  const navigate = useNavigate();
  const [username, setUsername] = useState(localStorage.getItem('userName'));
  
  const companyId = localStorage.getItem('company_id'); 
  const userId = localStorage.getItem('user_id'); 
  const branchId = localStorage.getItem('branch_id'); 

  useEffect(() => {
    const openShift = async () => {
      const shiftData = {
        company_id: companyId,
        branch_id: branchId,
        operator_id: userId,
        shift_status: "open",
        date_time_open: new Date().toISOString(),
        date_time_close: null, // Set to null for an open shift
        shift_comment: `Opened by ${username}`,
        syncid: null // Set this as needed
      };

      try {
        const response = await fetch('http://localhost:3009/shift', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(shiftData),
        });

        if (!response.ok) {
          throw new Error('Failed to open shift');
        }

        const result = await response.json();
        Swal.fire({
          title: 'Success!',
          text: 'Shift opened successfully!',
          icon: 'success'
        });

        // Redirect to the dashboard or another page
        navigate('/XGoDashboard');
      } catch (error) {
        console.error('Error opening shift:', error);
        Swal.fire({
          title: 'Error!',
          text: error.message,
          icon: 'error'
        });
      }
    };

    openShift();
  }, [navigate, companyId, userId, branchId, username]);

  return (
    <div className="text-center mt-5">
      <h2>Opening Shift...</h2>
      <p>Please wait while we open your shift.</p>
    </div>
  );
};

export default XGoOpenShift;